import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login/login';
import { Dashboard } from '@/pages/hainok/Dashboard/dashboard';
import { Settings } from './pages/Settings/settings';
import { Users } from '@/pages/hainok/Users/users';
import { Accounts } from '@/pages/hainok/Accounts/accounts';
import { Authenticator } from '@/pages/hainok/Authenticator/authenticator';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/Layout/AppLayout';
import { ThemeProvider } from './components/UIProviders';
import { api, useGetMeQuery } from '@/store/api';
import { Suspense, useEffect } from 'react';
import { store } from './store';
import { InmopublicUsers } from '@/pages/inmopublic/Users/inmopublicUsers';
import { InmopublicAccounts } from '@/pages/inmopublic/Accounts/inmopublicAccounts';
import { InmopublicMemberships } from '@/pages/inmopublic/Memberships/inmopublicMemberships';

function App() {
  const { isSuccess } = useGetMeQuery(); // This will trigger the query to check auth status
  const isAuthenticated = isSuccess;

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'logout') {
        store.dispatch(api.util.resetApiState());
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    // <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
    <ThemeProvider>
      <Routes>
        <Route path='/login' element={isAuthenticated ? <Navigate to='/dashboard' replace /> : <Login />} />
        <Route
          path='/dashboard'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Dashboard />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path='/settings'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path='/users'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Users />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path='/accounts'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Accounts />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path='/authenticator'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Authenticator />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path='/inmopublic/*'
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path='/' element={<Navigate to='/inmopublic/users' replace />} />
                  <Route
                    path='/users'
                    element={
                      // Lazy load the Inmopublic Users component
                      <Suspense fallback={<div>Loading...</div>}>
                        <InmopublicUsers />
                      </Suspense>
                    }
                  />
                  <Route
                    path='/accounts'
                    element={
                      // Lazy load the Inmopublic Accounts component
                      <Suspense fallback={<div>Loading...</div>}>
                        <InmopublicAccounts />
                      </Suspense>
                    }
                  />
                  <Route
                    path='/memberships'
                    element={
                      // Lazy load the Inmopublic Memberships component
                      <Suspense fallback={<div>Loading...</div>}>
                        <InmopublicMemberships />
                      </Suspense>
                    }
                  />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route path='/' element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />} />
        <Route path='*' element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
